export type LRCPropsType = {
  onClickOpen: boolean;
  setOnClickOpen: (openState: boolean) => void;
};

export type HLAMessageContentType = {
  aliciId: number;
  aliciSunucuId: number;
  gonderenId: number;
  icerik: {
    federasyonOlusturulacak: boolean;
    federateType: string;
    federationName: string;
    fomTipi: number;
    rtiHost: string;
    rtiPort: string;
  };
  mesajAltTipi: number;
  mesajTipi: number;
  oyunId: number;
  zipliMi: boolean;
};

export enum EFederateTipi {
  HYMOTS_C = 1,
  ETECUBE,
}

export enum ELRCConnectionStatus {
  LOADING,
  CONNECTED,
  DISCONNECTED,
}

export type LRCState = {
  federationName: string;
  federateName: string;
  federateType: EFederateTipi;
  rtiHost: string;
  rtiPort: string;
  federasyonOlusturulacak: boolean;
  isDisconnectedFromFederation?: boolean;
};

export enum ELRCMessageContentKeys {
  'FEDERATION NAME' = 'federationName',
  'FEDERATE NAME' = 'federateName',
  'FEDERATE TYPE' = 'federateType',
  'RTI HOST' = 'rtiHost',
}

export const lrcState: LRCState = {
  federasyonOlusturulacak: false,
  federationName: '',
  federateType: EFederateTipi.ETECUBE,
  federateName: '',
  rtiHost: '',
  rtiPort: '',
};

export interface TableItem {
  module: string;
  status: string;
}

export const columns = [
  {
    title: 'MODULE',
    dataIndex: 'module',
    width: '50%',
  },
  {
    title: 'INFO',
    dataIndex: 'status',
    width: '50%',
  },
];

export const mergedColumns = columns.map((col) => {
  return {
    ...col,
    onCell: (record: TableItem) => ({
      record,
      inputtype: col.dataIndex === 'type' ? 'number' : 'text',
      dataindex: col.dataIndex,
      title: record[col.dataIndex as keyof TableItem]?.toString() || '',
    }),
  };
});

export function calculateSpeedKmH(velocity: { vectorX: number; vectorY: number; vectorZ: number }) {
  const { vectorX, vectorY, vectorZ } = velocity;

  const speedMS = Math.sqrt(vectorX ** 2 + vectorY ** 2 + vectorZ ** 2);

  const speedKmH = speedMS * 3.6;

  return speedKmH;
}

export enum HLAEchelonEnum {
  NONE = 0,
  TEAM = 1,
  CREW = 2,
  SQUAD = 3,
  SECTION = 4,
  PLATOON = 5,
  DETACHMENT = 6,
  COMPANY = 7,
  BATTERY = 8,
  TROOP = 9,
  BATTALION = 10,
  SQUADRON = 11,
  REGIMENT = 12,
  GROUP = 13,
  BRIGADE = 14,
  DIVISION = 15,
  CORPS = 16,
  ARMY = 17,
  ARMYGROUP = 18,
  FRONT = 19,
  REGION = 20,
}

export enum HLAForceIdentifierEnum {
  OTHER = 0,
  FRIENDLY = 1,
  OPPOSING = 2,
  NEUTRAL = 3,
  FRIENDLY_2 = 4,
  OPPOSING_2 = 5,
  NEUTRAL_2 = 6,
  FRIENDLY_3 = 7,
  OPPOSING_3 = 8,
  NEUTRAL_3 = 9,
  FRIENDLY_4 = 10,
  OPPOSING_4 = 11,
  NEUTRAL_4 = 12,
  FRIENDLY_5 = 13,
  OPPOSING_5 = 14,
  NEUTRAL_5 = 15,
  FRIENDLY_6 = 16,
  OPPOSING_6 = 17,
  NEUTRAL_6 = 18,
  FRIENDLY_7 = 19,
  OPPOSING_7 = 20,
  NEUTRAL_7 = 21,
  FRIENDLY_8 = 22,
  OPPOSING_8 = 23,
  NEUTRAL_8 = 24,
  FRIENDLY_9 = 25,
  OPPOSING_9 = 26,
  NEUTRAL_9 = 27,
  FRIENDLY_10 = 28,
  OPPOSING_10 = 29,
  NEUTRAL_10 = 30,
  FRIENDLY_11 = 31,
  OPPOSING_11 = 32,
  NEUTRAL_11 = 33,
  FRIENDLY_12 = 34,
  OPPOSING_12 = 35,
  NEUTRAL_12 = 36,
  FRIENDLY_13 = 37,
  OPPOSING_13 = 38,
  NEUTRAL_13 = 39,
  FRIENDLY_14 = 40,
  OPPOSING_14 = 41,
  NEUTRAL_14 = 42,
}
